import { motion } from "framer-motion";

export const FadeUp = ({ children, delay = 0, className = "", y = 24 }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);

export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0.3 }) => (
    <motion.span
        className={className}
        initial="hidden"
        animate="show"
        variants={{ hidden: {}, show: { transition: { staggerChildren: 0.16, delayChildren: delay } } }}
    >
        {lines.map((line, i) => (
            <span key={i} className="block overflow-hidden pb-1">
                <motion.span
                    className={`block ${lineClassName}`}
                    variants={{
                        hidden: { y: "115%" },
                        show: { y: "0%", transition: { duration: 1, ease: [0.22, 1, 0.36, 1] } },
                    }}
                >
                    {line}
                </motion.span>
            </span>
        ))}
    </motion.span>
);
